"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

_Object$defineProperty(exports, "KakaoMap", {
  enumerable: true,
  get: function get() {
    return _KakaoMap.default;
  }
});

_Object$defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _Marker.default;
  }
});

_Object$defineProperty(exports, "MarkerContext", {
  enumerable: true,
  get: function get() {
    return _Marker.MarkerContext;
  }
});

_Object$defineProperty(exports, "CustomOverlay", {
  enumerable: true,
  get: function get() {
    return _CustomOverlay.default;
  }
});

_Object$defineProperty(exports, "CustomOverlayWithString", {
  enumerable: true,
  get: function get() {
    return _CustomOverlayWithString.default;
  }
});

_Object$defineProperty(exports, "usePlaceService", {
  enumerable: true,
  get: function get() {
    return _usePlaceService.default;
  }
});

exports.default = void 0;

var _KakaoMap = _interopRequireWildcard(require("./MapLib/KakaoMap"));

var _Marker = _interopRequireWildcard(require("./MapLib/Marker"));

var _CustomOverlay = _interopRequireDefault(require("./MapLib/CustomOverlay"));

var _CustomOverlayWithString = _interopRequireDefault(require("./MapLib/CustomOverlayWithString"));

var _usePlaceService = _interopRequireDefault(require("./hooks/usePlaceService"));

// export default KakaoMapContext;
var _default = {
  KakaoMapContext: _KakaoMap.KakaoMapContext
};
exports.default = _default;